import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { JsonService } from '../../../services/core/json.service';
import { TaskApiResources } from './task.constants';

@Injectable({
  providedIn: 'root',
})
export class TaskDataService {
  private baseURL: any;

  constructor(private http: HttpClient, private jsonService: JsonService) {
    this.baseURL = TaskApiResources;
  }

  list(model: any): Observable<any> {
    const endPoint = `${this.baseURL.list}`;
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  create(model: any): Observable<any> {
    const endPoint = `${this.baseURL.create}`;
    console.log('create', endPoint);
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  copy(id: any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.copy}/${id}/copy`;
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  search(model: any): Observable<any> {
    const endPoint = `${this.baseURL.search}`;
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  detail(id: any, params?: any): Observable<any> {
    const endPoint = `${this.baseURL.detail}/${id}`;
    return this.http.get<any>(endPoint, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  update(id: any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.update}/${id}`;
    return this.http.patch<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Bulk delete: DELETE tasks/delete/multiple with { task_ids: [...] }
  deleteMultiple(taskIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteMultiple}`;
    return this.http.request<any>('delete', endPoint, { body: { task_ids: taskIds } }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Pre-check which of the selected tasks can be deleted (and why not, for the rest)
  deleteAvailability(taskIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteAvailability}`;
    return this.http.post<any>(endPoint, { task_ids: taskIds }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  delete(id: any): Observable<any> {
    const endPoint = `${this.baseURL.delete}/${id}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  updateStatus(id: any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.updateStatus}/${id}`;
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  searchTaskReferenceNumber(model: any) {
    const endPoint = `${this.baseURL.taskSearch}`;
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  taskStatuses() {
    const endPoint = `${this.baseURL.taskStatuses}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  getPendingCount(userId: number | string) {
    const endPoint = `${this.baseURL.pendingCount}`;
    const params = new HttpParams().set('user_id', String(userId));
    return this.http.get<any>(endPoint, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
